import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Header from "../../components/Header/Header";
import {
  breadCrumbArray2,
  convertDateToObj,
  getAsOfDate,
  getSubAssetClasses,
  isFromGivenPage,
  isValueExist,
  logEvents,
  trackEventWithScreen,
} from "../../utils/functions";
import { observer } from "mobx-react";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import {
  fromSnippetSub,
  OVERALL,
  PERFORMANCE_PAGE,
} from "../../utils/constants";
import PageTitle from "../../components/PageTitle/PageTitle";

const Performance = () => {
  const location = useLocation();
  const [locationArr, setLocationArr] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSnippetNSubAssetNavigated, setisSnippetNSubAssetNavigated] =
    useState(false);

  const performanceRef = useRef();

  const secPageReturnData = PerformanceStore.secPageReturnData;
  const performanceInstrumentDetails = PerformanceStore.instrumentDetails;
  const performanceAssetClassId = PerformanceStore.selectedAssetClass.id;
  const { performanceRoute2, performanceRoute1, performanceRoute4 } =
    useParams();
  const routes = performanceRoute2?.split("_");
  //const handleClickFun = (index) => {};

  const setNavigation = (newArr, newArr2) => {
    if (performanceRoute1 !== "derivatives")
      setLocationArr(
        breadCrumbArray2(
          PerformanceStore.selectedAssetClass.id,
          newArr2,
          PerformanceStore?.secPageReturnData?.instrumentVehicle?.name ||
            getSubAssetClasses(routes?.[1] || ""),
          PerformanceStore?.instrumentDetails?.[0]?.instrument?.name
        ).slice(1)
      );
    else
      setLocationArr(
        breadCrumbArray2(
          PerformanceStore.selectedAssetClass.id,
          newArr,
          performanceRoute2 === "1" ? "Futures " : "Options "
        ).slice(1)
      );

    if (performanceRoute4 !== undefined) {
      setLocationArr((prevState) => {
        prevState.pop();
        return prevState;
      });
    }
  };

  performanceRef.current = setNavigation;

  useEffect(() => {
    const newArr = location.pathname.split("/");
    const newArr2 = [...newArr];
    performanceRef.current(newArr, newArr2);
  }, [
    location.pathname,
    secPageReturnData,

    performanceInstrumentDetails,
    performanceAssetClassId,
  ]);

  useEffect(() => {
    if (
      !UserStore.fromPerformance &&
      PerformanceStore.isHydrated &&
      UserStore.isHydrated
    ) {
      PerformanceStore.setLoaderClosingCheck({});

      let locationObj = {};

      location.state?.from
        ? (locationObj = { ...location.state })
        : (locationObj = {});

      if (
        PerformanceStore.currentLoader !== "mainTabLoader" &&
        !PerformanceStore.mainTabLoader
      ) {
        PerformanceStore.setCurrentLoader("fullScreen");
        AuthStore.updateLoadingFullScreen(true);
      }
      if (
        isFromGivenPage({ page: fromSnippetSub, location }) &&
        !isSnippetNSubAssetNavigated
      ) {
        setisSnippetNSubAssetNavigated(true);
        PerformanceStore.setData("selectedAssetClass", {
          id: "all",
          name: "Overall",
        });
        locationObj = {
          ...locationObj,
          duration: PerformanceStore.secPageSelectedDuration,
        };
      }

      // this will call first pages api on first time visiting page and changing assetclasses
      if (performanceRoute2 === undefined) {
        // If user is navigating through url directly after login , then it will set overall as selected asset class
        if (!PerformanceStore.isSelectedPresent) {
          PerformanceStore.setAssetClassOnly();
          PerformanceStore.setIsSelectedIdPresent(true);
        }
        PerformanceStore.setRef("");
        if (PerformanceStore.currentLoader !== "mainTabLoader")
          PerformanceStore.setDuration(
            PerformanceStore.secPageSelectedDuration
              ? PerformanceStore.secPageSelectedDuration
              : // : "ITD"
                PerformanceStore?.selectedDuration || "ITD"
          );
        PerformanceStore.setIsSecpage(false);
        //this will actual apis
        if (PerformanceStore.isClassIdChecked) {
          // This code will get called when the asset class id is checked
          if (PerformanceStore.selectedAssetClass.id === "all") {
            if (location?.state?.from) {
              const { assetClassId, section, duration } = locationObj;

              PerformanceStore.setAssetClassOnLinkClick({
                id: !isNaN(assetClassId) ? Number(assetClassId) : assetClassId,
                name: section,
              });
              PerformanceStore.setDuration(duration);
              PerformanceStore.setData("isAssetClassClicked", true);
            }
            PerformanceStore.onFirstLoad();
          } else {
            PerformanceStore.setFilterApplied("closed");
            PerformanceStore.onMainTabChange();
          }
        }
      }
    }

    return () => {};
    // eslint-disable-next-line
  }, [
    UserStore.isHydrated,
    PerformanceStore.isHydrated,
    location,
    PerformanceStore.selectedAssetClass.id,
    PerformanceStore.isClassIdChecked,
  ]);

  useEffect(() => {
    if (PerformanceStore.isHydrated && UserStore.isHydrated) {
      setLoading(false);
      PerformanceStore.setIsClassIdChecked(true);
    }
    return () => {};
    // eslint-disable-next-line
  }, [PerformanceStore.isHydrated, UserStore.isHydrated]);

  useEffect(() => {
    if (PerformanceStore.isHydrated && UserStore.isHydrated) {
      if (performanceRoute2 === undefined)
        PerformanceStore.setIsClassIdChecked(true);
      else if (
        PerformanceStore.isClassIdChecked &&
        !PerformanceStore.PerformanceApiCalled
      )
        PerformanceStore.setIsClassIdChecked(false);
    }
  }, [PerformanceStore.isHydrated, UserStore.isHydrated, location]);

  useEffect(() => {
    trackEventWithScreen({ eventName: PERFORMANCE_PAGE, screenName: OVERALL });
    logEvents(PERFORMANCE_PAGE, { screenName: OVERALL });

    let duration = isValueExist({
      value: PerformanceStore.secPageSelectedDuration,
      value2: PerformanceStore?.selectedDuration,
      defaultValue: "ITD",
    });

    PerformanceStore.setData("persistedSecPageDuration", "");
    PerformanceStore.setDuration(duration);

    return () => {
      PerformanceStore.loaderCloseOnFail();
      PerformanceStore.setData("isAssetClassClicked", false);
      //  PerformanceStore.setDuration("ITD", "returned");
    };
  }, []);

  useEffect(() => {
    if (UserStore.isHydrated && false) {
      const asOfDateObj = convertDateToObj(getAsOfDate(UserStore.asOfDate));
      PerformanceStore.setData(
        "fromDatePerf",
        PerformanceStore.fromDatePerf
          ? PerformanceStore.fromDatePerf
          : asOfDateObj,
        "abc"
      );
      PerformanceStore.setData(
        "toDatePerf",
        PerformanceStore.toDatePerf ? PerformanceStore.toDatePerf : asOfDateObj,
        "bbc"
      );
    }
  }, [UserStore.isHydrated, UserStore.asOfDate]);

  return (
    <>
      <PageTitle title={"Performance"} />
      {AuthStore.isLoadingFullScreen ||
      !PerformanceStore.isHydrated ||
      !UserStore.isHydrated ||
      loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <Header type="performance" />
          <div className="performance_outer">
            {" "}
            <div className="outer_bread">
              <BreadCrumb
                locationArr={locationArr}
                //clickFunction={(index) => handleClickFun(index)}
                parentName={"performance"}
              />
            </div>
          </div>
          <Outlet />
        </div>
      )}
    </>
  );
};

export default observer(Performance);
